import {gql} from '@apollo/client';

export const GET_TMS_PUBLISHED_TASK_BY_DRIVER = gql`
  query GetTmsPublishedTaskByDriver {
    getTmsPublishedTaskByDriver {
      taskWayPointId
      sequence
      wayPointName
      zipcode
      addressLine1
      addressLine2
      country
      state
      city
      quantity
      planArrivalTime
      planArrivalTimezone
      actualArrivalTime
      actualArrivalTimezone
      planDepartureTime
      planDepartureTimezone
      actualDepartureTime
      actualDepartureTimezone
      status
      waypointType
      contactName
      contactPhone
      ext
      taskId
      warehouseId
      isFinished
      isAbnormal
      warehouseSiteType
      photosUrls
      unloadingPhotosUrls
      waypointTimezoneLocation
    }
  }
`;

export interface TmsWaypointWithAddressType {
  taskWayPointId: string;
  sequence: number;
  wayPointName?: string | null;
  zipcode?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  country?: string | null;
  state?: string | null;
  city?: string | null;
  quantity: number;
  planArrivalTime?: string | null;
  planArrivalTimezone?: string | null;
  actualArrivalTime?: string | null;
  actualArrivalTimezone?: string | null;
  planDepartureTime?: string | null;
  planDepartureTimezone?: string | null;
  actualDepartureTime?: string | null;
  actualDepartureTimezone?: string | null;
  status: string;
  waypointType?: number | null;
  contactName?: string | null;
  contactPhone?: string | null;
  ext?: string | null;
  taskId?: number | null;
  warehouseId?: number | null;
  isFinished: boolean;
  isAbnormal: boolean;
  warehouseSiteType?: number | null;
  photosUrls?: string[] | null;
  unloadingPhotosUrls?: string[] | null;
  waypointTimezoneLocation?: string | null;
}

export interface GetTmsPublishedTaskResponse {
  getTmsPublishedTaskByDriver: TmsWaypointWithAddressType[];
}